import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import type { TeamFormState } from '../types';
import { teamSchema } from '../validation/schema';

export const useTeamForm = (name = '') =>
  useForm<TeamFormState>({
    defaultValues: { name },
    resolver: zodResolver(teamSchema),
    // Submit stays disabled until a name is entered, so validity must track every keystroke.
    mode: 'onChange',
  });
